import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import './Blacklist.less';
import useBlacklistedTenants from './hooks/useBlacklistedTenants';
type Props = {
	show: boolean;
	label: {
		i18nKey: string;
		defaultValue: string;
	};
	blacklistIds?: string[];
};

const Blacklist = ({show, blacklistIds, label}: Props) => {
	const {loading, tenants} = useBlacklistedTenants(blacklistIds);
	return (
		<div
			className="blacklist"
			data-testid="blacklist"
			style={{
				opacity: show ? 1 : 0
			}}>
			<SpinnerContainer show={loading}>
				<label>
					<Trans i18nKey={label.i18nKey}>{label.defaultValue}</Trans>
				</label>
				<div className="tenants">
					{!!tenants.length && (
						<ul>
							{tenants.map((tenant) => (
								<li key={tenant.id}>{tenant.organisation.name}</li>
							))}
						</ul>
					)}
					{!loading && !tenants.length && (
						<Trans i18nKey="globaljobs.create.noblacklist">No customers are blacklisted</Trans>
					)}
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default Blacklist;
